<template>
  <MainLayout class="video-courses">
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-sm-10">
          <nav class="navbar navbar-toggleable navbar-light">
            <ul class="nav navbar-nav">
              <li class="nav-item">
                <router-link to="/video-courses" class="nav-link typography--body-3">
                  {{ $t('video_lectures.sub_header.video_courses') }}
                </router-link>
              </li>
              <li class="nav-item active">
                <router-link to="/video-lectures" class="nav-link typography--body-3">
                  {{ $t('video_lectures.sub_header.video_lectures') }}
                </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-sm-2 hidden-xs-down">
          <div class="sub-header-btn-row">
            <router-link to="/upload-video-lecture" class="btn btn-primary new-video-course-btn float-right">
              {{ $t('video_lectures.sub_header.new_video_lecture') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container mw-960 mt-27" slot="layout-body">
      <div class="row" v-if="loading">
        <div class="col-12 text-center">
          <LoadingBounce />
          <div class="typography--body-2 typography--color-disabled pb-5">
            {{ $t('common.loading') }}
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12 text-center mb-5 pb-5" v-if="lectures.length === 0">
          <div class="empty-list-text">
            <div class="typography--body-2 typography--color-disabled"
                 v-html="$t('video_lectures.no_lectures')">
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg-3" v-for="videoLecture in lectures" :key="videoLecture.id" v-else>
          <router-link :to="`/video-lectures/${videoLecture.id}`" tag="div" class="card-row">
            <VideoLectureItem :lecture="videoLecture" />
          </router-link>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-more" class="col-12 text-center mb-5 pb-5">
          </div>
        </InfiniteLoading>
      </div>
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { orderBy } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';
  import publisherOnly from '@/mixins/publisherOnly';
  import VideoLectureItem from '../components/VideoLectureItem';

  export default {
    name: 'video-lecture-list',

    mixins: [
      publisherOnly,
    ],

    components: {
      InfiniteLoading,
      VideoLectureItem,
    },

    data() {
      return {
        loading: false,
      };
    },

    computed: {
      ...mapGetters([
        'lecturesByCourseId',
        'currentUserId',
      ]),

      lectures() {
        return orderBy(this.lecturesByCourseId.null, ['created_at'], ['desc']);
      },
    },

    methods: {
      ...mapActions([
        'fetchMyVideoLectureList',
      ]),

      onInfinite() {
        const perPage = 10;
        const page = parseInt(this.lectures.length / perPage, 10) + 1;
        const params = {
          owner_id: this.currentUserId,
          order_by: '-created_at',
          video_course_id: 'null',
          per_page: perPage,
          page,
        };

        return this.fetchMyVideoLectureList(params)
          .then((videoLectureList) => {
            if (this.$refs.infiniteLoading) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

              if (videoLectureList.length < perPage) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              }
            }
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/video-lectures/views/VideoLectureList.vue